/* Adăugare rapidă în coș pe paginile de campanie: alegi mărimea direct de pe card. */
(function () {
  if (window.campaignQuickAdd) return;
  window.campaignQuickAdd = true;

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];

  function sizeRank(value) {
    var age = value.match(/\((\d+)\s*(ani|luni)\)/i);
    if (age) return parseInt(age[1], 10) * (age[2].toLowerCase() === 'luni' ? 1 : 12);
    var idx = SIZE_ORDER.indexOf(value.trim().toUpperCase());
    return idx === -1 ? 10000 : 1000 + idx;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  var sheet, overlay, body, state, lastTrigger;

  function build() {
    overlay = el('div', 'cqa-overlay');
    sheet = el('div', 'cqa-sheet');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Alege mărimea');
    sheet.tabIndex = -1;

    var close = el('button', 'cqa-close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Închide');
    close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    close.addEventListener('click', hide);

    body = el('div', 'cqa-body');
    sheet.appendChild(close);
    sheet.appendChild(body);
    document.body.appendChild(overlay);
    document.body.appendChild(sheet);

    overlay.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) hide();
    });
  }

  function open(data, priceNode) {
    if (!sheet) build();
    state = { data: data, selected: {} };
    body.innerHTML = '';

    var head = el('div', 'cqa-head');
    if (data.image) {
      var img = el('img', 'cqa-thumb');
      img.src = data.image;
      img.alt = '';
      head.appendChild(img);
    }
    var info = el('div', 'cqa-info');
    info.appendChild(el('p', 'cqa-title', data.title));
    if (priceNode) {
      var price = priceNode.cloneNode(true);
      price.classList.add('cqa-price');
      price.style.display = '';
      info.appendChild(price);
    }
    head.appendChild(info);
    body.appendChild(head);

    data.options.forEach(function (name, index) {
      var values = [];
      data.variants.forEach(function (v) {
        if (values.indexOf(v.options[index]) === -1) values.push(v.options[index]);
      });
      if (values.length === 1) {
        state.selected[index] = values[0];
        return;
      }
      if (/m[aă]rime|size/i.test(name)) {
        values.sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
      }
      var group = el('div', 'cqa-group');
      var labelRow = el('div', 'cqa-label-row');
      labelRow.appendChild(el('p', 'cqa-label', name));
      group.appendChild(labelRow);
      if (data.sizeGuide && /m[aă]rime|size/i.test(name)) {
        var guideBtn = el('button', 'cqa-guide-toggle', 'Ghid mărimi');
        guideBtn.type = 'button';
        guideBtn.setAttribute('aria-expanded', 'false');
        var guideImg = el('img', 'cqa-guide-image');
        guideImg.alt = 'Ghid mărimi XPLODE copii';
        guideImg.hidden = true;
        guideBtn.addEventListener('click', function () {
          if (!guideImg.src) guideImg.src = data.sizeGuide;
          guideImg.hidden = !guideImg.hidden;
          guideBtn.setAttribute('aria-expanded', guideImg.hidden ? 'false' : 'true');
          guideBtn.textContent = guideImg.hidden ? 'Ghid mărimi' : 'Ascunde ghidul';
        });
        labelRow.appendChild(guideBtn);
        group.appendChild(guideImg);
      }
      var list = el('div', 'cqa-values');
      values.forEach(function (value) {
        var btn = el('button', 'cqa-value', value);
        btn.type = 'button';
        btn.dataset.index = index;
        btn.dataset.value = value;
        btn.addEventListener('click', function () {
          state.selected[index] = value;
          list.querySelectorAll('.cqa-value').forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          refresh();
        });
        list.appendChild(btn);
      });
      group.appendChild(list);
      body.appendChild(group);
    });

    var error = el('p', 'cqa-error');
    error.hidden = true;
    body.appendChild(error);

    var minItems = parseInt(document.documentElement.getAttribute('data-free-shipping-items') || '0', 10);
    if (minItems > 0) {
      var ship = el('div', 'cqa-shipping');
      ship.hidden = true;
      body.appendChild(ship);
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var after = cart.item_count + 1;
          var icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';
          if (cart.item_count >= minItems) return;
          if (after >= minItems) {
            ship.className = 'cqa-shipping cqa-shipping--done';
            ship.innerHTML = icon + '<span>Cu acest produs ai <strong>transport gratuit</strong>!</span>';
          } else {
            var left = minItems - after;
            ship.innerHTML = icon + '<span><strong>Transport gratuit la ' + minItems + ' produse.</strong> După acesta mai alegi ' + (left === 1 ? 'încă unul' : left + ' produse') + ' și nu plătești livrarea.</span>';
          }
          ship.hidden = false;
        })
        .catch(function () {});
    }

    var add = el('button', 'cqa-add button button--primary', 'Alege mărimea');
    add.type = 'button';
    add.addEventListener('click', submit);
    body.appendChild(add);

    var more = el('a', 'cqa-more', 'Vezi detalii produs');
    more.href = data.url;
    body.appendChild(more);

    refresh();
    document.documentElement.classList.add('cqa-lock');
    overlay.classList.add('is-open');
    sheet.classList.add('is-open');
    sheet.focus();
  }

  function matchingVariant() {
    var opts = state.data.options;
    for (var i = 0; i < opts.length; i++) if (state.selected[i] == null) return null;
    return state.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return state.selected[i] === o; });
    }) || null;
  }

  function refresh() {
    // Dezactivează valorile care nu au variantă disponibilă cu selecția curentă
    body.querySelectorAll('.cqa-value').forEach(function (btn) {
      var index = parseInt(btn.dataset.index, 10);
      var possible = state.data.variants.some(function (v) {
        if (!v.available || v.options[index] !== btn.dataset.value) return false;
        return v.options.every(function (o, i) {
          return i === index || state.selected[i] == null || state.selected[i] === o;
        });
      });
      btn.disabled = !possible;
    });
    var add = body.querySelector('.cqa-add');
    var variant = matchingVariant();
    add.disabled = !variant || !variant.available;
    add.textContent = variant ? (variant.available ? 'Adaugă în coș' : 'Stoc epuizat') : 'Alege mărimea';
  }

  function hide() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('cqa-lock');
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  function submit() {
    var variant = matchingVariant();
    if (!variant) return;
    var add = body.querySelector('.cqa-add');
    var error = body.querySelector('.cqa-error');
    add.disabled = true;
    add.textContent = 'Se adaugă…';
    error.hidden = true;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', 1);
    if (cart && cart.getSectionsToRender) {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || response.message);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'campaign-quick-add', productVariantId: variant.id });
        }
        hide();
        if (cart && cart.renderContents && response.sections) {
          cart.renderContents(response);
          var inner = cart.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          cart.classList.remove('is-empty');
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (e) {
        error.textContent = (e && e.message) || 'Nu am putut adăuga produsul. Încearcă din nou.';
        error.hidden = false;
        refresh();
      });
  }

  window.xplodeQuickAdd = {
    open: function (data, priceNode, trigger) {
      lastTrigger = trigger || null;
      open(data, priceNode);
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-campaign-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.product-card');
    var json = card && card.querySelector('[data-campaign-product]');
    if (!json) return;
    try {
      lastTrigger = btn;
      var offer = card.querySelector('.campaign-card__offer-price');
      var priceNode = offer && getComputedStyle(offer).display !== 'none' ? offer : card.querySelector('.price');
      open(JSON.parse(json.textContent), priceNode);
    } catch (err) {
      window.location = btn.closest('.product-card').querySelector('a[href*="/products/"]').href;
    }
  });
})();
